import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_mkanage_team() {
     const navigate = useNavigate();
    
      useEffect(() => {
        navigate('/manage_team'); 
      }, [navigate]); 
    
      return null; 
 
}
